import React from 'react';
import PropTypes from 'prop-types';
import './css/style.css';
import config from './config/config.json';
import LoadingSpinner from './LoadingSpinner.jsx';
import axios from 'axios';

const propTypes = {
    id: PropTypes.string.isRequired
};
var HostName = config.HostName;
class JwModal extends React.Component {
    static modals = [];
    static open = (id, name, accesskey, secretid, drive, deployedApps) => (e) => {
        e.preventDefault();
        let modal = JwModal.modals.find(x => x.props.id === id);
        modal.setState({ isOpen: true });
        modal.setState({ name: name });
        modal.setState({ accesskey: accesskey });
        modal.setState({ secretkey: secretid });
        modal.setState({ drive: drive });
        modal.setState({ deployedApps: deployedApps });
        document.body.classList.add('jw-modal-open');
    }

    static close = (id) => (e) => {
        e.preventDefault();
        // close modal specified by id
        let modal = JwModal.modals.find(x => x.props.id === id);
        modal.setState({ isOpen: false });
        document.body.classList.remove('jw-modal-open');
    }

    constructor(props) {
        super(props);
        this.handleDelete = this.handleDelete.bind(this);
        this.state = {
            isOpen: false,
            name: '',
            accesskey: '',
            secretkey: '',
            drive: '',
            deployedApps: []
        };

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // add this modal instance to the modal service so it's accessible from other components
        JwModal.modals.push(this);

    }

    componentWillUnmount() {
        // remove this modal instance from modal service
        JwModal.modals = JwModal.modals.filter(x => x.props.id !== this.props.id);
        this.element.remove();
    }

    handleClick(e) {
        // close modal on background click
        if (e.target.className === 'jw-modal') {
            JwModal.close(this.props.id)(e);
        }
    }

    handleDelete(vendorName, appName) {
        this.setState({ loading: true });
        var url = HostName + "/api/v1/deleteapp";
        axios.delete(url, {
            data: {
                "vendorname": vendorName,
                "appname": appName
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("accessToken")
            }, timeout: config.TimeOut
        })
            .then(delresp => {
                console.log("Deleting application successful");
                var newApps = this.state.deployedApps;
                for (var i = 0; i < newApps.length; i++) {
                    if (newApps[i].applicationName === appName) {
                        newApps.splice(i, 1);
                        this.setState({ deployedApps: newApps });
                    }
                }
                this.setState({ loading: false })
            }).catch(error => {
                console.log("Deleting application failed with an exception");
                this.setState({ loading: false });
            });
    }

    render() {
        return (
            <div style={{ display: + this.state.isOpen ? '' : 'none' }} onClick={this.handleClick} ref={el => this.element = el}>
                <div className="jw-modal modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title">Vendor Details</h2>
                        </div>
                        <div className="modal-body">
                            <div className="disableScroll">
                                <div>  <span className="font-weight-bold">Vendor Name :</span><span> {this.state.name}</span></div>
                                <div> <span className="font-weight-bold">Access Key :</span><span>{this.state.accesskey}</span></div>
                                <div>  <span className="font-weight-bold">Secret Key : </span><span>{this.state.secretkey}</span></div>
                                <div>  <span className="font-weight-bold">Drive : </span><span>{this.state.drive}</span></div>
                                <br />
                                <table className="table table-hover">
                                    <thead className='thead-dark'>
                                        <tr>
                                            <th className='text-center'>App Name</th>
                                            <th className='text-center'>Version</th>
                                            <th className='text-center'>Delete </th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        {this.state.deployedApps.map(((appRef, index) => {
                                            return (
                                                <tr key={appRef.applicationName}>
                                                    <td>{appRef.applicationName}</td>
                                                    <td>{appRef.applicationVersion}</td>
                                                    <td><span className=" glyphicon glyphicon-trash text-danger deleteStyling" onClick={e => this.handleDelete(this.state.name, appRef.applicationName)}></span></td>
                                                </tr>
                                            )
                                        }))}
                                    </tbody>
                                </table>
                                <br />
                            </div>
                        </div>
                        <div className="modal-footer">
                            {this.props.children}
                        </div>
                        <div>
                            {
                                this.state.loading ? <LoadingSpinner /> : null
                            }
                        </div>
                    </div>
                </div>
                <div className="jw-modal-background"></div>
            </div>
        );
    }
}

JwModal.propTypes = propTypes;

export default JwModal;


// WEBPACK FOOTER //
// ./src/JwModal.jsx